import { Image, Text, TokenTextAppearance, TokenTextColor, styled } from '@volkswagen-onehub/components-core';
import React, { useState, useEffect } from 'react';
import { ExteriorColors } from 'src/types';
import { CarlinePlaceholder } from '.';

const StyledContainer = styled.div`
  position: relative;
  margin-bottom: 17%;

  @media (min-width: 560px) {
    margin-bottom: 32%;
  }
  @media (min-width: 768px) {
    margin-bottom: 24%;
  }
  @media (min-width: 960px) {
    margin-bottom: 25%;
  }
`;

export interface CarlineColorCardBackgroundProps {
  color: string;
}

const StyledBackground = styled.div<CarlineColorCardBackgroundProps>`
  background-color: ${(props) => props.color};
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  padding-top: 42%;

  @media (min-width: 560px) {
    padding-top: 57%;
  }

  @media (min-width: 768px) {
    padding-top: 49%;
  }
  @media (min-width: 960px) {
    padding-top: 50%;
  }
`;

export interface CarlineColorCardTextProps {
  isInverted: boolean;
  isSelected: boolean;
}

const StyledTextWrapper = styled.div<CarlineColorCardTextProps>`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  padding: ${(props) => (props.isSelected ? '11px' : '24px')};
  text-align: left;
  color: ${(props) => (props.isInverted ? '#ffffff' : '#000000')};
`;

const StyledImagePlaceholder = styled.div`
  position: relative;
  /* padding-top: 37.8125%; */
  padding-top: 32.8125%;
`;

const StyledImageWrapper = styled.div<{ isPlaceHolder?: boolean }>`
  position: absolute;
  top: 0px;
  margin-top: ${(props) => (props.isPlaceHolder ? '8%' : '11%')};
  width: 100%;
  @media (min-width: 560px) {
    margin-top: ${(props) => (props.isPlaceHolder ? '23%' : '27%')};
  }
  @media (min-width: 768px) {
    margin-top: ${(props) => (props.isPlaceHolder ? '14%' : '17%')};
  }
  @media (min-width: 960px) {
    margin-top: ${(props) => (props.isPlaceHolder ? '15%' : '19%')};
  }
`;



export interface CarlineColorCardProps {
  carlineName: string;
  carlineImage: string;
  carlineColors?: ExteriorColors | string;
  isNew?: boolean;
  displayCarlineName?: boolean;
  isInverted?: boolean;
  isSelected: boolean;
}

export interface CarlineColorCardState {
  displayCarlineName?: boolean;
  finalColor: string;
  isInverted: boolean;
  isNew: boolean;
}

export const CarlineColorCard = (props: CarlineColorCardProps) => {
  const { carlineName, carlineImage, carlineColors, isNew, displayCarlineName, isInverted, isSelected }  = props;
  const [ finalColor, setFinalColor ] = useState(null);
  const [ isInvertedCheck, setIsInvertedCheck ] = useState(null);

  const displayCarlineNameCheck = displayCarlineName === undefined ? true : displayCarlineName;

  useEffect(()=>{
    if (carlineColors) {
      if (typeof carlineColors === 'object') {
        setFinalColor(carlineColors.hexadecimal);
        setIsInvertedCheck(carlineColors.invertido);
      } else {
        setFinalColor(carlineColors);
        setIsInvertedCheck(isInverted);
      }
    } else {
      setFinalColor('transparent');
      setIsInvertedCheck(false);
    }
  },[carlineColors]);

  return (
    <StyledContainer>
      <StyledBackground color={finalColor} />

      <StyledTextWrapper isInverted={isInvertedCheck} isSelected={isSelected}>
        {displayCarlineNameCheck ? (
          <Text appearance={TokenTextAppearance.headline300} bold color={TokenTextColor.inherit} staticSize>
            {isNew ? 'Nuevo ' : null}
            {carlineName}
          </Text>
        ) : null}
      </StyledTextWrapper>

      <StyledImagePlaceholder>
        <StyledImageWrapper className="styled-image-wrapper">
          {carlineImage ? (
            <Image src={carlineImage} alt={carlineName} />
          ) : (
            <CarlinePlaceholder isInverted={isInvertedCheck} />
          )}
        </StyledImageWrapper>
      </StyledImagePlaceholder>
    </StyledContainer>
  );
};
